export default "__VITE_ASSET__CGjGDT8O__"